import { useState, useEffect } from "react"
import { getWindowObject } from "./BrowserUtils"

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = getWindowObject()
  return {
    width,
    height,
  }
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  )

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions())
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return windowDimensions
}
